import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SizeEffects } from './size.effects';
import { initialState, reducer } from './size.reducer';
import { SizeState } from './size.state';
import { getEnvironment } from '../../features/shared/utils/get-environment';
import { createLocalStorageSyncReducer } from '../local-storage-sync';

const syncMetaReducer = createLocalStorageSyncReducer<SizeState>({
  keys: ['activePanels', 'sizes'],
  rehydrate: true,
  storage: sessionStorage,
  storageKeySerializer: (key) => `semeris-${getEnvironment()}-sizeState-${key}`,
});

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('size', reducer, { initialState, metaReducers: [syncMetaReducer] }),
    EffectsModule.forFeature([SizeEffects]),
  ],
  providers: [SizeEffects],
})
export class SizeStoreModule {}
